import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { Route, RouteLoader, RouteRenderer, Packet } from 'shared';
import { Subscription } from 'rxjs';
import { DxChartComponent } from 'devextreme-angular';

@Component({
  selector: 'app-tractors-history-graphs',
  templateUrl: './tractors-history-graphs.component.html',
  styleUrls: ['./tractors-history-graphs.component.scss']
})
export class TractorsHistoryGraphsComponent implements OnInit, OnDestroy {

  @Input()
  loader: RouteLoader;
  private loaderSub: Subscription;

  @Input()
  renderer: RouteRenderer;

  isLoading: boolean;
  ds: DataSource;
  store: ArrayStore;

  @ViewChild(DxChartComponent, { static: true })
  chartComponent: DxChartComponent;
  field = 'speed';
  unit = 'km/h';

  selectBoxOptions = {
    stylingMode: 'underlined',
    width: 140,
    value: 'speed',
    displayExpr: 'name',
    valueExpr: 'value',
    items: [
      { name: 'Vitesse', value: 'speed' },
      { name: 'Altitude', value: 'altitude' },
      { name: 'Carburant', value: 'fuel_level' },
      { name: 'Température', value: 'rs485_temperature' },
      { name: 'Humidité', value: 'rs485_humidity' }
    ],
    onValueChanged: (e) => {
      this.field = e.value;
      switch (this.field) {
        case 'speed':
          this.unit = 'km/h';
          break;
        case 'altitude':
          this.unit = 'm';
          break;
        case 'rs485_temperature':
          this.unit = '°C';
          break;
        case 'rs485_humidity':
          this.unit = '%';
          break;
        default:
          this.unit = '';
          break;
      }
    }
  };

  constructor(public host: ElementRef) {
    this.store = new ArrayStore({
      data: [],
    });
    this.ds = new DataSource({
      paginate: false,
      store: this.store,
    });

    // Bindings
    this.resetChart = this.resetChart.bind(this);
    this.exportChart = this.exportChart.bind(this);
    this.valueAxisAddUnit = this.valueAxisAddUnit.bind(this);
    this.chartPointClick = this.chartPointClick.bind(this);
  }

  ngOnInit(): void {
    this.loaderSub = this.loader.loading$.subscribe(isLoading => {
      this.isLoading = isLoading;
      if (isLoading) {
        this.clean();
      } else {
        this.build();
      }
    });
  }

  ngOnDestroy(): void {
    this.loaderSub.unsubscribe();
  }

  private clean() {
    this.store.clear();
  }

  private build() {
    this.loader.route.data.forEach(d => {
      this.store.insert(d);
    });
    this.ds.reload();
  }

  resetChart() {
    this.chartComponent.instance.resetVisualRange();
  }

  exportChart() {
    this.chartComponent.instance.exportTo('historique', 'png');
  }

  valueAxisAddUnit(label) {
    return label.valueText + ' ' + this.unit;
  }

  chartPointClick(e: any) {
    this.renderer.flyToPacket(new Packet(e.target.data));
  }
}
